import script from "./ItemsSaleSpeed.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemsSaleSpeed.vue?vue&type=script&setup=true&lang=js"

import "./ItemsSaleSpeed.vue?vue&type=style&index=0&id=4d1ca965&scoped=true&lang=css"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d1ca965"]])

export default __exports__